import { useState } from "react";
import { getStationCode } from "../../network/NetworkUtil";
import { getUserLogin } from "../../resources/EmployeeResource";

export const FileTransferUtil = ({
  getDownloadUrl,
  getUploadUrl,
  fileName,
  onUploadSuccess,
  errorMessages = {},
  fileType = "json",
}) => {
  const [isValidFile, setIsValidFile] = useState(null);
  const [alertMessage, setAlertMessage] = useState("");
  const [error, setError] = useState(false);

  const defaultErrorMessages = {
    fileNotExist: `${fileName} file does not exist. Please upload a valid one.`,
    networkError: "Network Error",
    downloadFailed: "Failed to download the file.",
    uploadFailed: "File upload failed!",
    invalidFile: "The file is not valid",
    noFileSelected: "Please select a file first!",
    uploadSuccess: "File uploaded successfully!",
    ...errorMessages,
  };

  const handleDownload = async () => {
    setIsValidFile(null);
    setAlertMessage("");

    try {
      const response = await getDownloadUrl();
      if (response.status === 200) {
        const stationCode = getStationCode();
        const preSignedUrl = response.data.url;
        const s3Response = await fetch(preSignedUrl);

        if (s3Response.status === 200) {
          const blob = await s3Response.blob();
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute(
            "download",
            `${stationCode}_${fileName}.${fileType}`,
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
          setError(false);
        } else {
          setError(true);
          setAlertMessage(defaultErrorMessages.fileNotExist);
        }
      } else {
        setError(true);
        setAlertMessage(defaultErrorMessages.networkError);
      }
    } catch (error) {
      setError(true);
      setAlertMessage(`${defaultErrorMessages.downloadFailed} Error: ${error}`);
    }
  };

  const uploadFile = async (fileData) => {
    try {
      const response = await getUploadUrl();
      if (response.status === 200) {
        const preSignedUrl = response.data.url;

        let body, updatedData;
        if (fileType === "csv") {
          // For CSV files, keep content as-is and don't spread string
          body = fileData;
          updatedData = {
            lastUpdatedBy: await getUserLogin(),
            lastUpdatedAt: Math.round(Date.now() / 1000),
          };
        } else {
          // For JSON files, spread works correctly on objects
          updatedData = {
            ...fileData,
            lastUpdatedBy: await getUserLogin(),
            lastUpdatedAt: Math.round(Date.now() / 1000),
          };
          body = JSON.stringify(updatedData);
        }

        const contentType =
          fileType === "csv" ? "text/csv" : "application/json";

        const s3Response = await fetch(preSignedUrl, {
          method: "PUT",
          headers: {
            "Content-Type": contentType,
          },
          body: body,
        });

        if (s3Response.ok) {
          setError(false);
          setAlertMessage(defaultErrorMessages.uploadSuccess);
          if (onUploadSuccess) {
            onUploadSuccess(updatedData);
          }
        } else {
          setError(true);
          setAlertMessage(defaultErrorMessages.uploadFailed);
        }
      } else {
        setError(true);
        setAlertMessage(defaultErrorMessages.networkError);
      }
    } catch (error) {
      setError(true);
      setAlertMessage(`Error uploading file. Error: ${error}`);
    }
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (fileType === "json") {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const result = e.target.result;
          try {
            const parsedData = JSON.parse(result);
            setIsValidFile(true);
            setAlertMessage("");
            await uploadFile(parsedData);
          } catch (error) {
            setIsValidFile(false);
            setError(true);
            setAlertMessage(defaultErrorMessages.invalidFile);
          }
        };
        reader.readAsText(selectedFile);
      } else {
        // For CSV files, upload directly without reading content
        setIsValidFile(true);
        setAlertMessage("");
        uploadFile(selectedFile);
      }
    } else {
      setError(true);
      setAlertMessage(defaultErrorMessages.noFileSelected);
    }
  };

  return {
    isValidFile: isValidFile,
    alertMessage,
    error,
    handleDownload,
    handleFileChange,
  };
};



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/FileTransferUtil.js